import { render, staticRenderFns } from "./AcceptableUsePolicy.vue?vue&type=template&id=43cb9c5c&scoped=true"
var script = {}
import style0 from "./AcceptableUsePolicy.vue?vue&type=style&index=0&id=43cb9c5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43cb9c5c",
  null
  
)

export default component.exports